import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  RestAlterationFeature,
  UpgradableNumber
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  obj: RestAlterationFeature;
  onChange: (changed: RestAlterationFeature) => void; 
  disabled: boolean;
}

export default function RestAlterationFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Rest Types"
          options={["Short","Long"]}
          values={obj.rest_types}
          multiple
          disabled={disabled}
          onChange={(changed: ("Short" | "Long")[]) => {
            obj.rest_types = changed;
            onChange(obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox
          name="Healing Multiplier"
          value={obj.healing_multiplier}
          disabled={disabled}
          onChange={(changed: UpgradableNumber) => {
            obj.healing_multiplier.copy(changed);
            onChange(obj);
            setPing(!ping);
          }}
        />
      </Grid>
    </Grid>
  );
}
